module.exports = __webpack_public_path__ + "d60f45a2d3f4b766996df0dbb4d5b336.svg";